import type { Settings } from '@brighterly/lib-core-types/customer/interfaces'
import type { FeatureTourConfig, FeatureTourStore } from '@stores/feature-tour/interfaces'

import { useSettingsStore } from '@stores/settings'

import { useAppBrand } from '@composables/tools/app-brand.hook'

const isTourFinishedInSettings = (config: FeatureTourConfig): boolean => {
  const key = config.finishedSettingsKey
  if (!key) {
    return false
  }

  const settingsStore = useSettingsStore()
  const settings = settingsStore.settings as (Settings & Record<string, unknown>) | null
  return !!settings?.[key]
}

export const actions = {
  startTour (this: FeatureTourStore, payload: FeatureTourConfig): void {
    if (useAppBrand().isSmartestMinds) {
      return
    }

    if (this.isActive && this.activeTourId === payload.stepsConfig.id) {
      return
    }

    if (isTourFinishedInSettings(payload)) {
      return
    }

    this.activeTourId = payload.stepsConfig.id
    this.activeTour = payload
    this.currentStepIndex = 0
    this.isActive = true
    this.isVisible = false
  },
  finishTour (this: FeatureTourStore): void {
    this.activeTourId = null
    this.activeTour = null
    this.currentStepIndex = 0
    this.isVisible = false
    this.isActive = false
  },
  setVisible (this: FeatureTourStore, payload: boolean): void {
    this.isVisible = payload
  },
  setCurrentStepIndex (this: FeatureTourStore, payload: number): void {
    const stepsCount = this.activeTour?.stepsConfig.steps.length ?? 0
    if (stepsCount === 0) {
      this.currentStepIndex = 0
      return
    }

    const maxIndex = stepsCount - 1
    this.currentStepIndex = Math.min(Math.max(payload, 0), maxIndex)
  },
  registerSpot (this: FeatureTourStore, id: string, element: HTMLElement): void {
    this.spotRegistry.set(id, element)
  },
  unregisterSpot (this: FeatureTourStore, id: string): void {
    this.spotRegistry.delete(id)
  },
}
